import React from 'react';
import { LayoutGrid } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { CAT_ICONS, colorFor } from './articleUtils';

const Tile = ({ active, onClick, icon, label, count, tileCls, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`shrink-0 flex items-center justify-between gap-4 min-w-[150px] sm:min-w-[160px] px-4 py-3.5 rounded-2xl border text-start transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 ${active ? 'bg-blue-600 border-blue-600 text-white shadow-lg shadow-blue-600/25' : 'bg-white border-slate-200 text-slate-800 hover:shadow-md'}`}
  >
    <div>
      <div className="font-bold text-sm sm:text-[15px]">{label}</div>
      <div className={`text-xs mt-0.5 ${active ? 'text-blue-100' : 'text-slate-400'}`}>({count})</div>
    </div>
    <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-lg ${active ? 'bg-white/15 text-white' : tileCls}`}>{icon}</div>
  </button>
);

export const ArticleCategoryTiles = ({ categories, posts, active, onChange, testPrefix = 'articles-cat' }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const withCounts = categories
    .map(c => ({ ...c, count: posts.filter(p => p.categories.includes(c.value)).length }))
    .filter(c => c.count > 0);
  return (
    <div data-testid={`${testPrefix}-tiles`} className="flex gap-3 overflow-x-auto pb-2 mb-8 scrollbar-thin">
      <Tile active={active === 'all'} onClick={() => onChange('all')} testId={`${testPrefix}-all`}
        icon={<LayoutGrid className="w-5 h-5" />} label={L('الكل', 'All')} count={posts.length} tileCls="bg-blue-50 text-blue-600" />
      {withCounts.map(c => {
        const Icon = CAT_ICONS[c.value];
        return (
          <Tile key={c.value} active={active === c.value} onClick={() => onChange(c.value)} testId={`${testPrefix}-${c.value}`}
            icon={Icon ? <Icon className="w-5 h-5" /> : <span>{c.icon}</span>}
            label={lang === 'ar' ? c.ar : c.en} count={c.count} tileCls={colorFor(categories, c.value).tile} />
        );
      })}
    </div>
  );
};
